export const SET_PROFILE_SETTINGS = 'SET_PROFILE_SETTINGS'